import react, { useContext } from "react";
import styled from "styled-components";
import WorkspaceContext from "../../../WorkspaceContext";
import {
  CARTAZ_GRANDE,
  CARTAZ_MEDIO,
  CARTAZ_PEQUENO,
} from "../../EncarteConstants";

const PriceContainer = styled.div`
  display: flex;
  flex-direction: direction-column;
  align-items: center;
  justify-content: center;
`;

const PriceLabel = styled.span`
  font-size: ${({ canvasScale }) => 48 * canvasScale}px;
  font-weight: bold;
  margin-right: ${({ canvasScale }) => 5 * canvasScale}px;
`;

const PriceSmallDigits = styled.span`
  font-size: 0.5em;
  vertical-align: super;
  position: relative;

  &:after {
    content: "";
    width: 100%;
    background-color: #111111;
    bottom: 0;
    right: 0;
    position: absolute;
    height: ${({ canvasScale }) => 10 * canvasScale}px;
    border-radius: ${({ canvasScale }) => 10 * canvasScale}px;
  }
`;

const DEFAULT_PRICE_LENGTH = 4; // ex: 9,99

const PRICE_FONT_SIZE_BY_FORMAT_AND_LENGTH = {
  [CARTAZ_PEQUENO]: {
    4: 280,
    5: 200,
    6: 180,
  },
  [CARTAZ_MEDIO]: {
    4: 420,
    5: 320,
    6: 280,
  },
  [CARTAZ_GRANDE]: {
    4: 1000,
    5: 800,
    6: 600,
  },
};

const getPriceFontSize = (format, priceLength = DEFAULT_PRICE_LENGTH) => {
  const formatFontSizes =
    PRICE_FONT_SIZE_BY_FORMAT_AND_LENGTH[format] ||
    PRICE_FONT_SIZE_BY_FORMAT_AND_LENGTH[CARTAZ_MEDIO];

  return (
    formatFontSizes[priceLength] ||
    formatFontSizes[DEFAULT_PRICE_LENGTH] ||
    PRICE_FONT_SIZE_BY_FORMAT_AND_LENGTH[CARTAZ_MEDIO][DEFAULT_PRICE_LENGTH]
  );
};

const PriceValue = styled.span`
  font-size: ${({ canvasScale, styles, priceLength }) =>
    getPriceFontSize(styles?.format, priceLength) * canvasScale}px;

  line-height: 0.8;
`;

const getNormalizedPrice = (price) => {
  if (price === null || price === undefined || price === "") {
    return "0,00";
  }

  return String(price).trim();
};

const getPriceLength = (price) => {
  const normalizedPrice = getNormalizedPrice(price);
  return normalizedPrice.replace(/\s/g, "").length;
};

const splitPriceByLastTwoDigits = (price) => {
  const normalizedPrice = getNormalizedPrice(price);
  const match = normalizedPrice.match(/^(.*?)(,\d{2})$/);

  if (!match) {
    return {
      mainPart: normalizedPrice,
      lastTwoDigits: "",
    };
  }

  return {
    mainPart: match[1],
    lastTwoDigits: match[2],
  };
};

export default function CartazProductDisplayPrice({
  product,
  canvasScale,
  styles,
}) {
  const price = product.promotionPrice || 0;
  const normalizedPrice = getNormalizedPrice(price);
  const priceLength = getPriceLength(normalizedPrice);
  const { mainPart, lastTwoDigits } =
    splitPriceByLastTwoDigits(normalizedPrice);

  return (
    <PriceContainer canvasScale={canvasScale}>
      <PriceLabel canvasScale={canvasScale}>R$</PriceLabel>
      <PriceValue
        canvasScale={canvasScale}
        styles={styles}
        priceLength={priceLength}
      >
        {mainPart}
        <PriceSmallDigits canvasScale={canvasScale}>
          {lastTwoDigits}
        </PriceSmallDigits>
      </PriceValue>
    </PriceContainer>
  );
}
